import { AssetFinanceAssetAge } from '__core/shared/model/assetFinance/AssetFinanceAssetAge.enum';
import { AssetFinanceAssetType } from '__core/shared/model/assetFinance/AssetFinanceAssetType.enum';
import { AssetFinanceProductType } from '__core/shared/model/assetFinance/AssetFinanceProductType.enum';
import { AssetFinanceVendorType } from '__core/shared/model/assetFinance/AssetFinanceVendorType.enum';
import stAdditionalProducts from './additionalProducts.component';
import stAssetDetails from './assetDetails.component';
import assetDetailsAdditionalInfo from './assetDetailsAdditionaInfo.component';
import stAssetDetailsQuickQuote from './assetDetailsQuickQuote.component';
import assetFinanceController from './assetFinance.controller';
import AssetFinance from './assetFinance.model';
import assetFinanceService from './assetFinance.service';
import stAssetFinanceCommissions from './assetFinanceCommissions.component';
import AssetFinanceCompareProduct from './assetFinanceCompareProduct.model';
import stAssetFinanceCompareProducts from './assetFinanceCompareProducts.component';
import stAssetFinanceCompliance from './assetFinanceCompliance.component';
import AssetFinanceCompliance from './assetFinanceCompliance.model';
import AssetFinanceDetail from './assetFinanceDetail.model';
import AssetFinanceDetailAdditionalInfo from './AssetFinanceDetailAdditionalInfo.model';
import AssetFinanceInsurance from './assetFinanceInsurance.model';
import AssetFinanceInsuranceType from './assetFinanceInsuranceType.model';
import AssetFinanceProposal from './assetFinanceProposal.model';
import AssetFinanceProposalAmortizationSchedule from './assetFinanceProposalAmortizationSchedule.model';
import stAssetFinanceProposalAmortizationScheduleComponent from './assetFinanceProposalAmortizationSchedule.component';
import AssetFinanceProposalAssociatedFee from './assetFinanceProposalAssociatedFee.model';
import AssetFinanceProposalAssociatedFeeType from './assetFinanceProposalAssociatedFeeType.model';
import assetFinanceQuickQuoteController from './assetFinanceQuickQuote.controller';
import AssetFinanceSearchProduct from './assetFinanceSearchProduct.model';
import AssetFinanceVerificationApplicant from './assetFinanceVerificationApplicant.model';
import stFinanceProposal from './financeProposal.component';
import stFinanceProposalQuickQuote from './financeProposalQuickQuote.component';
import stLenderAndProduct from './lenderAndProduct.component';
import stLenderAndProductQuickQuote from './lenderAndProductQuickQuote.component';
import stPreliminaryAssessment from './preliminaryAssessment.component';

export default angular
  .module('st.AssetFinance', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .factory('AssetFinanceAssetAge', () => AssetFinanceAssetAge)
  .factory('AssetFinanceAssetType', () => AssetFinanceAssetType)
  .factory('AssetFinanceProductType', () => AssetFinanceProductType)
  .factory('AssetFinanceVendorType', () => AssetFinanceVendorType)
  .factory('AssetFinance', AssetFinance)
  .factory('AssetFinanceCompareProduct', AssetFinanceCompareProduct)
  .factory('AssetFinanceCompliance', AssetFinanceCompliance)
  .factory('AssetFinanceDetail', AssetFinanceDetail)
  .factory('AssetFinanceDetailAdditionalInfo', AssetFinanceDetailAdditionalInfo)
  .factory('AssetFinanceInsurance', AssetFinanceInsurance)
  .factory('AssetFinanceInsuranceType', AssetFinanceInsuranceType)
  .factory('AssetFinanceProposal', AssetFinanceProposal)
  .factory('AssetFinanceProposalAmortizationSchedule', AssetFinanceProposalAmortizationSchedule)
  .factory('AssetFinanceProposalAssociatedFee', AssetFinanceProposalAssociatedFee)
  .factory('AssetFinanceProposalAssociatedFeeType', AssetFinanceProposalAssociatedFeeType)
  .factory('AssetFinanceSearchProduct', AssetFinanceSearchProduct)
  .factory('AssetFinanceVerificationApplicant', AssetFinanceVerificationApplicant)
  .component('stAdditionalProducts', stAdditionalProducts)
  .component('stAssetDetails', stAssetDetails)
  .component('assetDetailsAdditionalInfo', assetDetailsAdditionalInfo)
  .component('stAssetDetailsQuickQuote', stAssetDetailsQuickQuote)
  .controller('assetFinanceController', assetFinanceController)
  .component('stAssetFinanceCommissions', stAssetFinanceCommissions)
  .service('assetFinanceService', assetFinanceService)
  .component('stAssetFinanceCompareProducts', stAssetFinanceCompareProducts)
  .component('stAssetFinanceCompliance', stAssetFinanceCompliance)
  .component(
    'stAssetFinanceProposalAmortizationSchedule',
    stAssetFinanceProposalAmortizationScheduleComponent
  )
  .controller('assetFinanceQuickQuoteController', assetFinanceQuickQuoteController)
  .component('stFinanceProposal', stFinanceProposal)
  .component('stFinanceProposalQuickQuote', stFinanceProposalQuickQuote)
  .component('stLenderAndProduct', stLenderAndProduct)
  .component('stLenderAndProductQuickQuote', stLenderAndProductQuickQuote)
  .component('stPreliminaryAssessment', stPreliminaryAssessment)
  .constant('ASSET_FINANCE', {
    API: {},
    DETAILS: {
      ASSET_TYPE: [
        { id: 0, value: 'Select one', weight: 1, isConsumer: true, isCommercial: true },
        { id: 0, value: 'Not essential', weight: 1, isConsumer: true, isCommercial: true },
        {
          id: 1,
          value: 'Passenger vehicle (up to 9 pax)',
          weight: 2,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'PASSENGER_VEHICLE_PAX9'
        },
        {
          id: 2,
          value: 'Passenger vehicle (Taxi)',
          weight: 3,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'PASSENGER_VEHICLE_TAXI'
        },
        {
          id: 3,
          value: 'Passenger vehicle (hire car)',
          weight: 4,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'PASSENGER_VEHICLE_HIRE'
        },
        {
          id: 4,
          value: 'Light commercial (up to 3.5t)',
          weight: 5,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'LIGHT_COMMERCIAL_T35'
        },
        {
          id: 5,
          value: 'Light commercial (up to 4.5t)',
          weight: 6,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'LIGHT_COMMERCIAL_T45'
        },
        {
          id: 6,
          value: 'Light commercial (up to 5.0t)',
          weight: 7,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'LIGHT_COMMERCIAL_T50'
        },
        {
          id: 7,
          value: 'Light commercial (up to 12.0t)',
          weight: 8,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'LIGHT_COMMERCIAL_T072'
        },
        {
          id: 8,
          value: 'Truck',
          weight: 9,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'TRUCK'
        },
        {
          id: 9,
          value: 'Prime mover',
          weight: 10,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'PRIME_MOVER'
        },
        {
          id: 10,
          value: 'Heavy trailer (truck towed)',
          weight: 11,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          searchField: 'TRAILER_HEAVY'
        },
        {
          id: 11,
          value: 'Light trailer (car towed)',
          weight: 12,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: true,
          searchField: 'TRAILER_LIGHT'
        },
        {
          id: 12,
          value: 'Bus',
          weight: 13,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'BUS'
        },
        {
          id: 13,
          value: 'Motorbike',
          weight: 14,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'MOTORBIKE'
        },
        {
          id: 14,
          value: 'Motorbike on road',
          weight: 15,
          isConsumer: true,
          isCommercial: false,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'MOTORBIKE_ON_ROAD'
        },
        {
          id: 15,
          value: 'Motorbike of road',
          weight: 16,
          isConsumer: true,
          isCommercial: false,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'MOTORBIKE_OFF_ROAD'
        },
        {
          id: 16,
          value: 'Boats, Motors and Trailer packages',
          weight: 17,
          isConsumer: true,
          isCommercial: false,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'BOATS_MOTORS_AND_TRAILER_PACKAGES'
        },
        {
          id: 17,
          value: 'Golf carts',
          weight: 18,
          isConsumer: true,
          isCommercial: false,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'GOLF_CARTS'
        },
        {
          id: 18,
          value: 'Caravan',
          weight: 19,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: true,
          searchField: 'CARAVAN'
        },
        {
          id: 19,
          value: 'Marine',
          weight: 20,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'MARINE'
        },
        {
          id: 20,
          value: 'Medical',
          weight: 21,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'MEDICAL'
        },
        {
          id: 21,
          value: 'Earthmoving (including Yellow Goods)',
          weight: 22,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'EARTH'
        },
        {
          id: 22,
          value: 'Materials handling',
          weight: 23,
          isConsumer: false,
          isCommercial: true,
          showHours: true,
          searchField: 'MATERIALS'
        },
        {
          id: 23,
          value: 'Mining (including Yellow Goods)',
          weight: 24,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'MINING'
        },
        {
          id: 24,
          value: 'Plant and equipment',
          weight: 25,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'PLANT'
        },
        {
          id: 25,
          value: 'Agriculture',
          weight: 26,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'AGRICULTURE'
        },
        {
          id: 26,
          value: 'Tractor',
          weight: 27,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'TRACTOR'
        },
        {
          id: 27,
          value: 'Manufacturing',
          weight: 28,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          showHours: true,
          searchField: 'MANUFACTURING'
        },
        {
          id: 28,
          value: 'Crane',
          weight: 29,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'CRANE'
        },
        {
          id: 29,
          value: 'Access Equipment',
          weight: 30,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'ACCESS'
        },
        {
          id: 30,
          value: 'Forestry',
          weight: 31,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'FORESTRY'
        },
        {
          id: 31,
          value: 'Telephony',
          weight: 32,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'TELEPHONY'
        },
        {
          id: 32,
          value: 'IT',
          weight: 33,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'IT'
        },
        {
          id: 33,
          value: 'Business equipment',
          weight: 34,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'BUSINESS'
        },
        {
          id: 34,
          value: 'Gym',
          weight: 35,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'GYM'
        },
        {
          id: 35,
          value: 'Solar/energy efficient',
          weight: 36,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'SOLAR'
        },
        {
          id: 36,
          value: 'Aircraft',
          weight: 37,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showHours: true,
          searchField: 'AIRCRAFT'
        },
        {
          id: 37,
          value: 'Fit out',
          weight: 38,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          searchField: 'FIT_OUT'
        },
        {
          id: 38,
          value: 'Vending machines',
          weight: 39,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'VENDING'
        },
        {
          id: 39,
          value: 'Poker machines',
          weight: 40,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          searchField: 'POKER'
        },
        {
          id: 40,
          value: 'EEEF',
          weight: 41,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: true,
          showMileage: true,
          searchField: 'EEEF'
        },
        {
          id: 41,
          value: 'Unsecured',
          weight: 42,
          isConsumer: true,
          isCommercial: false,
          isPeperPrimary: false,
          searchField: 'UNSECURED'
        },
        {
          id: 42,
          value: 'Cashflow',
          weight: 43,
          isConsumer: false,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'CASHFLOW'
        },
        {
          id: 43,
          value: 'Non standard',
          weight: 44,
          isConsumer: true,
          isCommercial: true,
          isPeperPrimary: false,
          searchField: 'NON_STANDARD'
        }
      ],
      ASSET_AGE: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'New', weight: 2 },
        { id: 2, value: 'Used', weight: 3 },
        { id: 3, value: 'Demo', weight: 4 }
      ],
      CAR_TYPE: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'Sedan', weight: 2 },
        { id: 2, value: 'Wagon', weight: 3 },
        { id: 3, value: 'Utility', weight: 4 }
      ],
      VENDOR_TYPE: [
        { id: 0, value: 'Select one', isConsumer: true, isCommercial: true, weight: 1 },
        { id: 0, value: 'Not essential', isConsumer: true, isCommercial: true, weight: 1 },
        {
          id: 1,
          value: 'Dealer',
          isConsumer: true,
          isCommercial: true,
          weight: 2,
          searchField: 'DEALER'
        },
        {
          id: 2,
          value: 'Franchised dealer',
          isConsumer: true,
          isCommercial: true,
          weight: 3,
          searchField: 'FRANCHISED_DEALER'
        },
        {
          id: 3,
          value: 'Private',
          isConsumer: true,
          isCommercial: true,
          weight: 4,
          searchField: 'PRIVATE'
        },
        {
          id: 4,
          value: 'Refinance',
          isConsumer: true,
          isCommercial: true,
          weight: 5,
          searchField: 'REFINANCE'
        },
        {
          id: 5,
          value: 'Buyback',
          isConsumer: true,
          isCommercial: true,
          weight: 6,
          searchField: 'BUYBACK'
        },
        {
          id: 6,
          value: 'Rollover',
          isConsumer: true,
          isCommercial: true,
          weight: 7,
          searchField: 'ROLLOVER'
        },
        {
          id: 7,
          value: 'Capital raising',
          isConsumer: false,
          isCommercial: true,
          weight: 8,
          searchField: 'CAPITAL_RAISING'
        }
      ],
      PRODUCT_TYPE: [
        {
          id: 0,
          value: 'Select one',
          weight: 1,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true
        },
        {
          id: 1,
          value: 'Chattel mortgage',
          weight: 2,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true,
          searchField: 'CHATTEL_MORTGAGE',
          isDisabled: false
        },
        {
          id: 2,
          value: 'Lease',
          weight: 3,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true,
          searchField: 'LEASE',
          isDisabled: false
        },
        {
          id: 3,
          value: 'Novated lease',
          weight: 4,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true,
          searchField: 'NOVATED_LEASE',
          isDisabled: false
        },
        {
          id: 4,
          value: 'Consumer loan (NCCP)',
          weight: 4,
          isConsumer: true,
          isCommercial: false,
          isQuickTool: false,
          searchField: 'CONSUMER_LOAN_NCCP',
          isDisabled: false
        },
        {
          id: 5,
          value: 'Rental',
          weight: 5,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true,
          searchField: 'RENTAL',
          isDisabled: false
        },
        {
          id: 6,
          value: 'IPF',
          weight: 6,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: false,
          searchField: 'INSURANCE_PREMIUM_FINANCED',
          isDisabled: false
        },
        {
          id: 7,
          value: 'Operating lease',
          weight: 7,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: true,
          searchField: 'OPERATING_LEASE',
          isDisabled: false
        },
        {
          id: 8,
          value: 'Escrow',
          weight: 8,
          isConsumer: false,
          isCommercial: true,
          isQuickTool: false,
          searchField: 'ESCROW',
          isDisabled: false
        }
      ],
      INSURANCE_PRODUCT_TYPE: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'Income protection', weight: 2 },
        { id: 2, value: 'Life insurance', weight: 3 },
        { id: 3, value: 'Trauma', weight: 4 },
        { id: 4, value: 'TPD', weight: 5 },
        { id: 5, value: 'Building insurance', weight: 6 },
        { id: 6, value: 'Landlord insurance', weight: 7 },
        { id: 7, value: 'Other insurance', weight: 8 }
      ],
      INCOME_VERIFICATION_COMPLETED: [
        { id: 1, value: 'Payslips', weight: 1 },
        { id: 2, value: 'Bank statements', weight: 2 },
        { id: 3, value: 'Tax assessment documents', weight: 3 },
        { id: 4, value: 'Financial statements', weight: 4 },
        { id: 5, value: 'Employer letter', weight: 5 },
        { id: 6, value: 'Employer verbal reference', weight: 6 },
        { id: 7, value: 'Employment contract', weight: 7 },
        { id: 8, value: 'Loan statements', weight: 8 },
        { id: 9, value: 'Credit file', weight: 9 },
        { id: 10, value: 'Dividend statements', weight: 10 },
        { id: 11, value: 'Rental receipts or ledger', weight: 11 },
        { id: 12, value: 'Landlord/RE agent verbal confirmation', weight: 12 },
        { id: 13, value: 'Accountant letter', weight: 13 },
        { id: 14, value: 'Accountant verbal confirmation', weight: 14 },
        { id: 15, value: 'Other', weight: 15 }
      ],
      PAYMENT_FREQUENCY: [
        {
          id: 26,
          value: 'Fortnightly',
          weight: 1,
          isConsumer: true,
          isCommercial: false,
          llField: 'FORTNIGHTLY'
        },
        {
          id: 12,
          value: 'Monthly',
          weight: 2,
          isConsumer: true,
          isCommercial: true,
          llField: 'MONTHLY'
        },
        {
          id: 4,
          value: 'Quarterly',
          weight: 3,
          isConsumer: false,
          isCommercial: true,
          llField: 'QUARTERLY'
        },
        {
          id: 1,
          value: 'Annual',
          weight: 4,
          isConsumer: false,
          isCommercial: true,
          llField: 'ANNUAL'
        }
      ],
      MONTHLY_REPAYMENTS: [
        { id: 0, value: 'Select one' },
        { id: 1, value: '0-100' },
        { id: 2, value: '101-200' },
        { id: 3, value: '201-300' },
        { id: 4, value: '301-400' },
        { id: 5, value: '401-500' },
        { id: 6, value: '501-600' },
        { id: 7, value: '601-700' },
        { id: 8, value: '701-800' },
        { id: 9, value: '801-900' },
        { id: 10, value: '901-1000' },
        { id: 11, value: 'over the 1001' }
      ],
      INTEREST_RATES: [
        { id: 0, value: 'Select one' },
        { id: 1, value: '1-4%' },
        { id: 2, value: '4-7%' },
        { id: 3, value: '7-10%' },
        { id: 4, value: '10-13%' },
        { id: 5, value: '13-17%' },
        { id: 6, value: '17-20%' },
        { id: 7, value: '20-23%' },
        { id: 8, value: '23-26%' },
        { id: 9, value: '26-29%' },
        { id: 10, value: '29-32%' },
        { id: 11, value: 'over the 32%' }
      ],
      CREDIT_RECORD: [
        { id: 0, value: 'No selection made' },
        { id: 1, value: 'Good (applicant is certain their credit record is good)' },
        { id: 2, value: 'Bad (applicant has known credit issues)' },
        { id: 3, value: 'Unsure (applicant does not know)' }
      ],
      SEARCH: {
        ASSET_AGE: [
          { id: -1, value: 'Not essential', weight: 1 },
          { id: 0, value: 'New', weight: 2 },
          { id: 1, value: '1 year', weight: 3 },
          { id: 2, value: '2 years', weight: 4 },
          { id: 3, value: '3 years', weight: 5 },
          { id: 4, value: '4 years', weight: 6 },
          { id: 5, value: '5 years', weight: 7 },
          { id: 6, value: '6 years', weight: 8 },
          { id: 7, value: '7 years', weight: 9 },
          { id: 8, value: '8 years', weight: 10 },
          { id: 9, value: '9 years', weight: 11 },
          { id: 10, value: '10 years', weight: 12 },
          { id: 11, value: '11 years', weight: 13 },
          { id: 12, value: '12 years', weight: 14 },
          { id: 13, value: '13 years', weight: 15 },
          { id: 14, value: '14 years', weight: 16 },
          { id: 15, value: '15 years', weight: 17 },
          { id: 16, value: '16 years', weight: 18 },
          { id: 17, value: '17 years', weight: 19 },
          { id: 18, value: '18 years', weight: 20 },
          { id: 19, value: '19 years', weight: 21 },
          { id: 20, value: '20 years', weight: 22 }
        ],
        LOAN_TYPES: [
          { id: '', value: 'Select one', isConsumer: false, isCommercial: true, weight: 1 },
          {
            id: 'FULL_DOC',
            value: 'Full doc',
            isConsumer: true,
            isCommercial: true,
            weight: 2
          },
          {
            id: 'LOW_DOC',
            value: 'Low doc',
            isConsumer: false,
            isCommercial: true,
            weight: 3
          },
          {
            id: 'SELF_DEC',
            value: 'Self dec',
            isConsumer: false,
            isCommercial: true,
            weight: 4
          },
          {
            id: 'REPLACEMENT_POLICY',
            value: 'Replacement policy',
            isConsumer: false,
            isCommercial: true,
            weight: 5
          }
        ],
        YES_NO_OPTION: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'YES', value: 'Yes', weight: 2 },
          { id: 'NO', value: 'No', weight: 3 }
        ],
        ELAPSED_TIME_FROM_PAYOUT: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'GREATER_THAN_OR_EQUAL_1_MONTH', value: '1 month', weight: 2 },
          { id: 'GREATER_THAN_OR_EQUAL_3_MONTHS', value: '3 months', weight: 3 },
          { id: 'GREATER_THAN_OR_EQUAL_6_MONTHS', value: '6 months', weight: 4 },
          { id: 'GREATER_THAN_OR_EQUAL_12_MONTHS', value: '12 months', weight: 5 }
        ],
        ELAPSED_TERM_OLD_LOAN: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'LESS_THAN_3_MONTHS', value: 'Less than 3 months', weight: 2 },
          { id: 'LESS_THAN_6_MONTHS', value: 'Less than 6 months', weight: 3 },
          { id: 'LESS_THAN_12_MONTHS', value: 'Less than 12 months', weight: 4 },
          { id: 'LESS_THAN_18_MONTHS', value: 'Less than 18 months', weight: 5 }
        ],
        EMPLOYMENT_BASIS: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          {
            id: 'FULL_TIME',
            value: 'Full time',
            weight: 2
          },
          {
            id: 'PART_TIME',
            value: 'Part time',
            weight: 3
          },
          {
            id: 'CASUAL',
            value: 'Casual',
            weight: 4
          },
          {
            id: 'CONTRACT',
            value: 'Contract',
            weight: 5
          },
          {
            id: 'SELF_EMPLOYED',
            value: 'Self employed',
            weight: 5
          },
          {
            id: 'ON_PROBATION',
            value: 'On probation',
            weight: 6
          }
        ],
        TIME_AT_CURRENT_ADDRESS: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          {
            id: 'LESS_THAN_OR_EQUAL_3_MONTHS',
            value: 'Less than or equal 3 months',
            weight: 7
          },
          {
            id: 'LESS_THAN_OR_EQUAL_6_MONTHS',
            value: 'Less than or equal 6 months',
            weight: 6
          },
          {
            id: 'LESS_THAN_OR_EQUAL_12_MONTHS',
            value: 'Less than or equal 12 months',
            weight: 5
          },
          {
            id: 'LESS_THAN_OR_EQUAL_24_MONTHS',
            value: 'Less than or equal 24 months',
            weight: 4
          },
          {
            id: 'LESS_THAN_OR_EQUAL_36_MONTHS',
            value: 'Less than or equal 36 months',
            weight: 3
          },
          { id: 'GREATER_THAN_36_MONTHS', value: 'Greater than 36 months', weight: 2 }
        ],
        CREDIT_HISTORY: [
          {
            id: 'NOT_ESSENTIAL',
            value: 'Not essential',
            weight: 1,
            isConsumer: true,
            isCommercial: true
          },
          {
            id: 'GOOD',
            value: 'Good confirmable credit history',
            weight: 2,
            isConsumer: false,
            isCommercial: true
          },
          {
            id: 'NONE',
            value: 'No credit history',
            weight: 3,
            isConsumer: false,
            isCommercial: true
          },
          {
            id: 'EXCELLENT',
            value: 'Very extensive, excellent borrowing history',
            weight: 4,
            isConsumer: true,
            isCommercial: false
          },
          {
            id: 'GOOD',
            value: 'Sound overall credit history',
            weight: 5,
            isConsumer: true,
            isCommercial: false
          },
          {
            id: 'NONE',
            value: 'Minimal or no credit history',
            weight: 6,
            isConsumer: true,
            isCommercial: false
          },
          {
            id: 'ADVERSE',
            value: 'Adverse on credit file',
            weight: 7,
            isConsumer: true,
            isCommercial: true
          }
        ],
        ABN_REGISTERED: [
          { id: -1, value: 'Not essential', weight: 1 },
          { id: 0, value: 'Not registered', weight: 7 },
          { id: 11, value: 'Less than 12 months', weight: 6 },
          { id: 12, value: 'Greater than or equal 12 months', weight: 5 },
          { id: 24, value: 'Greater than or equal 24 months', weight: 4 },
          { id: 36, value: 'Greater than or equal 36 months', weight: 3 },
          { id: 60, value: 'Greater than or equal 60 months', weight: 2 }
        ],
        GST_REGISTERED: [
          { id: -1, value: 'Not essential', weight: 1 },
          { id: 0, value: 'Not registered', weight: 7 },
          { id: 11, value: 'Less than 12 months', weight: 6 },
          { id: 12, value: 'Greater than or equal 12 months', weight: 5 },
          { id: 24, value: 'Greater than or equal 24 months', weight: 4 },
          { id: 36, value: 'Greater than or equal 36 months', weight: 3 },
          { id: 60, value: 'Greater than or equal 60 months', weight: 2 }
        ],
        HOME_OWNERSHIP: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          {
            id: 'OWNER_W_EQUITY_GT_20',
            value: 'Property owner with equity greater than 20%',
            weight: 2
          },
          {
            id: 'OWNER_W_EQUITY_LT_20',
            value: 'Property owner with equity less than 20%',
            weight: 3
          },
          { id: 'RENT', value: 'Rent', weight: 4 },
          { id: 'BOARD', value: 'Board', weight: 5 },
          { id: 'OTHER', value: 'Other', weight: 6 }
        ],
        TIME_IN_EMPLOYMENT: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          {
            id: 'LESS_THAN_OR_EQUAL_3_MONTHS',
            value: 'Less than or equal 3 months',
            weight: 7
          },
          {
            id: 'LESS_THAN_OR_EQUAL_6_MONTHS',
            value: 'Less than or equal 6 months',
            weight: 6
          },
          {
            id: 'LESS_THAN_OR_EQUAL_12_MONTHS',
            value: 'Less than or equal 12 months',
            weight: 5
          },
          {
            id: 'LESS_THAN_OR_EQUAL_24_MONTHS',
            value: 'Less than or equal 24 months',
            weight: 4
          },
          {
            id: 'LESS_THAN_OR_EQUAL_36_MONTHS',
            value: 'Less than or equal 36 months',
            weight: 3
          },
          { id: 'GREATER_THAN_36_MONTHS', value: 'Greater than 36 months', weight: 2 }
        ],
        BALLOON_PAYMENT_DEBT_OPTIONS: [
          {
            id: 1,
            value:
              'Refinance to clear the balloon. They understand finance is subject to credit approval and will incur interest costs',
            weight: 1
          },
          { id: 2, value: 'Pay out the balloon from their own funds', weight: 2 },
          { id: 3, value: 'Sell or trade in the asset to meet the balloon payment', weight: 3 }
        ],
        UTILITY_AND_TEL_CO: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_DEFAULTS', value: 'No defaults', weight: 2 },
          { id: 'UP_TO_500', value: 'Up to $500', weight: 3 },
          { id: 'UP_TO_1000', value: 'Up to $1,000', weight: 3 },
          { id: 'UP_TO_1500', value: 'Up to $1,500', weight: 4 },
          { id: 'UP_TO_2000', value: 'Up to $2,000', weight: 5 },
          { id: 'UP_TO_5000', value: 'Up to $5,000', weight: 6 }
        ],
        FINANCIAL_DEFAULTS: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_DEFAULTS', value: 'No defaults', weight: 2 },
          { id: 'UP_TO_5000', value: 'Up to $5,000', weight: 3 },
          { id: 'FROM_5001_TO_30000', value: 'From $5,001 to $30,000', weight: 3 },
          { id: 'FROM_30001_TO_50000', value: 'From $30,001 to $50,000', weight: 4 },
          { id: 'FROM_50001_TO_60000', value: 'From $50,001 to $60,000', weight: 5 },
          { id: 'GREATER_THAN_60000', value: 'Greater than $60,000', weight: 6 }
        ],
        BANKRUPTS: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_BANKRUPTS', value: 'No bankrupts', weight: 2 },
          { id: 'MORE_THAN_6_MONTHS_AGO', value: 'More than 6 months ago', weight: 3 },
          { id: 'MORE_THAN_12_MONTHS_AGO', value: 'More than 12 months ago', weight: 3 },
          { id: 'MORE_THAN_24_MONTHS_AGO', value: 'More than 24 months ago', weight: 4 },
          { id: 'MORE_THAN_36_MONTHS_AGO', value: 'More than 36 months ago', weight: 5 },
          { id: 'MORE_THAN_60_MONTHS_AGO', value: 'More than 60 months ago', weight: 6 },
          { id: 'MORE_THAN_84_MONTHS_AGO', value: 'More than 84 months ago', weight: 7 }
        ],
        DEPOSIT_REQUIRED: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NOT_REQUIRED', value: 'Not required', weight: 2 },
          { id: 'TEN_PERCENT', value: '10%', weight: 3 },
          { id: 'FIFTEEN_PERCENT', value: '15%', weight: 3 },
          { id: 'TWENTY_PERCENT', value: '20%', weight: 4 },
          { id: 'TWENTY_FIVE_PERCENT', value: '25%', weight: 5 },
          { id: 'THIRTY_PERCENT', value: '30%', weight: 6 }
        ],
        MAX_NEGATIVE_EQUITY: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_NEGATIVE_EQUITY', value: 'No negative equity', weight: 2 },
          { id: 'FIVE_PERCENT', value: '5%', weight: 3 },
          { id: 'TEN_PERCENT', value: '10%', weight: 3 },
          { id: 'FIFTEEN_PERCENT', value: '15%', weight: 4 },
          { id: 'TWENTY_PERCENT', value: '20%', weight: 5 },
          { id: 'TWENTY_FIVE_PERCENT', value: '25%', weight: 6 },
          { id: 'THIRTY_PERCENT', value: '30%', weight: 7 }
        ],
        INCREASE_IN_REPAYMENT: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_INCREASE', value: 'No increase', weight: 2 },
          { id: 'ONE_HUNDRED_TWENTY_FIVE_PERCENT', value: '125%', weight: 3 },
          { id: 'ONE_HUNDRED_THIRTY_PERCENT', value: '130%', weight: 3 },
          { id: 'ONE_HUNDRED_THIRTY_FIVE_PERCENT', value: '135%', weight: 4 },
          { id: 'ONE_HUNDRED_FORTY_PERCENT', value: '140%', weight: 5 },
          { id: 'ONE_HUNDRED_FORTY_FIVE_PERCENT', value: '145%', weight: 6 },
          { id: 'ONE_HUNDRED_FIFTY_PERCENT', value: '150%', weight: 7 }
        ],
        PAY_DAY_ON_STATEMENTS: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_ENQUIRIES', value: 'No enquiries', weight: 2 },
          { id: 'NO_MORE_THAN_1_ENQUIRY', value: 'No more than 1 enquiry', weight: 3 },
          { id: 'NO_MORE_THAN_2_ENQUIRIES', value: 'No more than 2 enquiries', weight: 3 },
          { id: 'NO_MORE_THAN_3_ENQUIRIES', value: 'No more than 3 enquiries', weight: 4 },
          { id: 'NO_MORE_THAN_4_ENQUIRIES', value: 'No more than 4 enquiries', weight: 5 },
          { id: 'NO_MORE_THAN_5_ENQUIRIES', value: 'No more than 5 enquiries', weight: 6 },
          { id: 'NO_MORE_THAN_6_ENQUIRIES', value: 'No more than 6 enquiries', weight: 7 }
        ],
        PAY_DAY_ENQUIRES: [
          { id: 'NOT_ESSENTIAL', value: 'Not essential', weight: 1 },
          { id: 'NO_ENQUIRIES', value: 'No enquiries', weight: 2 },
          { id: 'MORE_THAN_1_MONTH_AGO', value: 'More than 1 month ago', weight: 3 },
          { id: 'MORE_THAN_3_MONTHS_AGO', value: 'More than 3 months ago', weight: 3 },
          { id: 'MORE_THAN_6_MONTHS_AGO', value: 'More than 6 months ago', weight: 4 },
          { id: 'MORE_THAN_9_MONTHS_AGO', value: 'More than 9 months ago', weight: 5 },
          { id: 'MORE_THAN_12_MONTHS_AGO', value: 'More than 12 months ago', weight: 6 },
          { id: 'MORE_THAN_18_MONTHS_AGO', value: 'More than 18 months ago', weight: 7 },
          { id: 'MORE_THAN_24_MONTHS_AGO', value: 'More than 24 months ago', weight: 8 }
        ]
      },
      LODGEMENT: {
        DRIVE_ONLINE_SUPPORTED_LENDERS: ['WBC', 'BOM', 'BSA', 'STG', 'CAF']
      }
    }
  });
